module.exports = {
	"header": "Meet Spotin at the FUTR Europe summit",
	"date": "2022/06/27",
	"imgSrc": "futr_london.png",
	"imgAlt": "Spotin x FUTR",
	"ingress": "We will be exhibiting at the FUTR Europe summit as a sponsor. We will be there to present and discuss our solution ‘Content Commerce’ that enables brands and sellers to retail their full product catalogue from within any type of online content, on any type of platform.",
	"sections": [
		{
			"paragraphs": [
				"Sounds interesting? Meet us at the Spotin booth at FUTR Europe summit-London at Queen Elizabeth II Centre. Our CEO & Founder-Kristoffer Karlsson, CFO & Co-Founder-Robert Karlsson and our Marketing & Sales Associate-Alba Danielsson will be there. Incase you are unable to visit us there, feel free to drop an email at <a href='mailto:marketing@spotin.com'>marketing@spotin.com</a> and we will get back to you."
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./pages/news/6/article.json
// module id = 19
// module chunks = 0